export const FORM_BLOCK = 'block';
export const FORM_QUALITY_STRATEGY = 'quality_strategy';
